import { CSSProperties, HTMLAttributeReferrerPolicy, useState } from "react";

const fallbackSrc = '/images/symptom-no-photo.jpg';

type ImageProps = {
  alt?: string | undefined;
  crossOrigin?: any;
  decoding?: "async" | "auto" | "sync" | undefined;
  fetchPriority?: "high" | "low" | "auto";
  height?: number | string | undefined;
  loading?: "eager" | "lazy" | undefined;
  referrerPolicy?: HTMLAttributeReferrerPolicy | undefined;
  sizes?: string | undefined;
  src?: string | undefined;
  srcSet?: string | undefined;
  useMap?: string | undefined;
  width?: number | string | undefined;
  style?: CSSProperties | undefined;
}

const Image = ({ ...props }: ImageProps) => {
  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
  }
  return <img
    src={error ? fallbackSrc : props.src}
    onError={handleError}
    style={props.style}
    width={props.width || '64px'}
    height={props.height || '64px'}
    alt={props.alt}
  />
}

export default Image;